var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_3316_25275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66663C11.0944 1.66663 12.1781 1.88217 13.1891 2.30096C14.2002 2.71975 15.1188 3.33358 15.8926 4.1074C16.6665 4.88123 17.2803 5.79989 17.6991 6.81093C18.1179 7.82198 18.3334 8.90562 18.3334 9.99997M10.0001 1.66663V9.99996M10.0001 1.66663C5.39771 1.66663 1.66675 5.39759 1.66675 9.99996C1.66675 14.6023 5.39771 18.3333 10.0001 18.3333C14.6025 18.3333 18.3334 14.6023 18.3334 9.99997M10.0001 1.66663C14.6025 1.66663 18.3334 5.39759 18.3334 9.99997M18.3334 9.99997L10.0001 9.99996M18.3334 9.99997C18.3334 11.3151 18.0222 12.6115 17.4251 13.7832C16.8281 14.955 15.9622 15.9688 14.8983 16.7418L10.0001 9.99996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3316_25275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.68e95cf9ce3688f8b53fe8413a369e97.svg";
export { ForwardRef as ReactComponent };